import * as React from "react";
const CanceledCochesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect
      x={4}
      y={5}
      width={16}
      height={10}
      rx={2}
      ry={2}
      fill="black"
      stroke="black"
      strokeWidth={1}
    />
    <rect x={5} y={6} width={3} height={3} fill="white" />
    <rect x={9} y={6} width={3} height={3} fill="white" />
    <rect x={13} y={6} width={3} height={3} fill="white" />
    <rect x={17} y={6} width={3} height={3} fill="white" />
    <circle cx={7} cy={16} r={2} fill="black" />
    <circle cx={17} cy={16} r={2} fill="black" />
    <line x1={2} y1={2} x2={22} y2={22} stroke="red" strokeWidth={2} />
    <circle cx={12} cy={12} r={10} stroke="red" strokeWidth={2} fill="none" />
  </svg>
);
export default CanceledCochesIcon